import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) => state.timeSlot.loading;
export const slotsErrorMessage = (state: RootState) => state.timeSlot.error;
export const timeSlotResponse = (state: RootState) =>
  state.timeSlot.timeSlotResponse;
